import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "srh__department-toggle flex h-[3.5714285rem] font-medium text-gray-70" }

import ToggleItem from "./ToggleItem.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'DepartmentToggle',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    _createVNode(ToggleItem, { "department-type": "damen" }, {
      default: _withCtx(() => _cache[0] || (_cache[0] = [
        _createTextVNode("Damen")
      ])),
      _: 1
    }),
    _createVNode(ToggleItem, { "department-type": "herren" }, {
      default: _withCtx(() => _cache[1] || (_cache[1] = [
        _createTextVNode("Herren")
      ])),
      _: 1
    }),
    _createVNode(ToggleItem, { "department-type": "kinder" }, {
      default: _withCtx(() => _cache[2] || (_cache[2] = [
        _createTextVNode("Kinder")
      ])),
      _: 1
    })
  ]))
}
}

})